import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import EditorialMarquee from '../components/EditorialMarquee';
import { Bottleneck, Workflow, Manifesto, Confidentiality, ForeignLawyers, TrustSignals } from '../components/Sections';
import ClaimForm from '../components/ClaimForm';
import { FadeUp } from '../components/Reveal';
import { COUNTRY_LIST } from '../data/countries';

const globalTrust = {
  title: 'A single Italian point of contact for cross-border creditors.',
  body:
    'Studio Legale Belliardo operates from Verona, serving foreign enterprises with claims against Italian debtors. Every file is handled by counsel of record; every step is documented.',
  bullets: [
    'Enforcement proceedings before Italian courts',
    'Every step delivered as a written, forwardable record',
    'Every document protected by Italian professional secrecy',
  ],
};

export default function Home() {
  return (
    <div className="relative">
      <Helmet>
        <title>An Italian Lawyer on Your Side in Italy | Studio Legale Belliardo — Verona</title>
        <meta name="description" content="An Italian lawyer on your side in Italy. Verona-based law firm helping foreign businesses recover money from Italian debtors." />
        <link rel="canonical" href="https://belliardo-international.com/" />
      </Helmet>
      <Nav />
      <Hero global />
      <EditorialMarquee />
      <Bottleneck body="Italian bureaucracy, notarised translations, distance and rigid court calendars slow foreign creditors down. Our office absorbs that friction and reduces every file to a documented, actionable procedural roadmap — with a single accountable point of contact in Verona." />
      <Workflow />

      {/* Markets grid */}
      <section className="relative bg-ink-950 py-24 md:py-40 border-t border-white/10" data-testid="section-markets">
        <div className="mx-auto max-w-[1600px] px-6 md:px-10">
          <div className="flex items-baseline gap-4 mb-10">
            <span className="font-serif italic text-white/40 text-5xl font-light leading-none">◐</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">— Markets served</span>
          </div>
          <FadeUp>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1] tracking-tight max-w-4xl">
              Foreign enterprises. <em className="not-italic text-white/50">One Italian practice.</em>
            </h2>
          </FadeUp>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-px bg-white/10 border border-white/10">
            {COUNTRY_LIST.map((c, i) => (
              <FadeUp key={c.code} delay={i * 0.05}>
                <Link
                  to={`/${c.code}`}
                  data-testid={`market-card-${c.code}`}
                  className="block bg-ink-900 h-full p-8 group relative overflow-hidden hover:bg-ink-800 transition-colors duration-500"
                >
                  <div className="h-0.5 w-10 mb-6" style={{ background: c.accent }} aria-hidden />
                  <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3">— {c.short}</div>
                  <div className="font-serif text-2xl text-white leading-tight mb-6">{c.label}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50 flex items-center gap-2 group-hover:text-white transition-colors">
                    View landing <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
                  </div>
                </Link>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <Manifesto />
      <Confidentiality />
      <TrustSignals trust={globalTrust} accent="#4A0404" />
      <ForeignLawyers />
      <ClaimForm />
      <Footer />
    </div>
  );
}
